(function() {
    'use strict';
var SaveSearchCtrl = function ($scope, $uibModalInstance, $timeout, passedModel) {

    console.log('SaveSearchCtrl init!');

    console.log('passedModel',passedModel);
    $scope.searchModel = {};
    if( !angular.isDefined(passedModel) ){
        passedModel = {}; // otherwise any ng-init inside modal will create the model in it's own child scope (inaccessible)
    }

    $scope.ngModel = passedModel; // whatever you need to use in the template - you may name your template model ngModel
    // $scope.formModel = passedModel; // or formModel - just mind it will be different formModel than rest of the page (just name share)

    $scope.ok = function() {
        console.log('this is the final model');
        console.log(this.ngModel);
        console.log('searchName'+$scope.searchModel.SearchName);
        this.ngModel.SearchName = $scope.searchModel.SearchName;
        this.ngModel.createPod = $scope.searchModel.createPod;
        $uibModalInstance.close(this.ngModel); // returnValue - the results will be passed back to xms-modal ng-model (passedModel)
        $timeout(function(){
           $('#primary').attr('action',WEBAPP_PATH+'/advancedSearch/save');// this should bypass the issue of g:form not initialising action using a angular formModel value.X3-5314
            $('.main').find('form').submit();
        });
    };

    $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };
}
SaveSearchCtrl.$inject = ['$scope', '$uibModalInstance', '$timeout', 'params'];
angular.module('app').controller('SaveSearchCtrl', SaveSearchCtrl);


}());
